import { Injectable } from '@angular/core';

import { Preferences } from '@capacitor/preferences';
import { App } from '@capacitor/app';

@Injectable({
  providedIn: 'root'
})
export class ScreenInitService {

  // Función para comprobar si es la primera vez que se abre la aplicación
  async checkIsFirstTime(): Promise<{ isFirstTime: string } | false> {
    const isFirstTime = await Preferences.get({ key: 'isFirstTime' });
    if (isFirstTime.value) {
      return { isFirstTime: isFirstTime.value };
    } else {
      return false;
    }
  }

  // Función para guardar el estado de la primera vez que se abre la aplicación
  async saveFirstTime(): Promise<void> {
    try {
      await Preferences.set({ key: 'isFirstTime', value: 'false' });
    } catch (error) {
      console.log('Error al guardar el estado de primera vez:', error);
    }
  }

  // Función para borrar el estado de la primera vez que se abre la aplicación
  async deleteFirstTime(): Promise<void> {
    try {
      await Preferences.remove({ key: 'isFirstTime' });
    } catch (error) {
      console.log('Error al borrar el estado de primera vez:', error);
    }
  }

}
